import {
  EXPIRY_NOTIFICATION_VISIBLE,
  EXPIRY_NOTIFICATION_NOT_VISIBLE,
} from '../constants/ActionTypes';

const expiryNotification = (
  state = {
    notificationIsOnScreen: false,
  },
  action
) => {
  switch (action.type) {
    case EXPIRY_NOTIFICATION_VISIBLE:
      return { ...state, notificationIsOnScreen: true };
    case EXPIRY_NOTIFICATION_NOT_VISIBLE:
      return { ...state, notificationIsOnScreen: false };
    default:
      return state;
  }
};

export default expiryNotification;
